import AgreeToTcModal from './AgreeToTcModal.component';

export default AgreeToTcModal;
